import './Spinner.css';

import React from 'react';

import PropTypes from 'prop-types';
import Component from 'react-pure-render/component';

export default class Spinner extends Component {
  static propTypes = {
    contain: PropTypes.bool
  };

  static defaultProps = {
    contain: false
  };

  render() {
    const { contain } = this.props;

    const style = contain ? { position: 'absolute' } : {};

    return (
      <div className="content-loader spin" style={style}>
        <div className="content-loader-inner">
          <div className="item-a"></div>
          <div className="item-b"></div>
        </div>
      </div>
    );
  }
}
